// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1k7SR","cell":"ColumnAccessor_cell__2-8kw","firstCellAccent":"ColumnAccessor_firstCellAccent__PAZ9k"};